'use strict'

import { VIEWS } from '@/views/names'
import { TIMER } from '@/store/types'
import { colorSchemes, layouts } from '@/app/const/settings'

export default {
  install (Vue, store, router) {
    Vue.prototype.$pageManager = {
      showLogin () {
        toPage(VIEWS.login)
      },
      showTableQueue () {
        const theme = store.state.gui.settings.colorScheme.code
        if (theme === colorSchemes.raif) {
          return toPage(VIEWS.table.custom.raif.queue)
        }

        const layout = store.state.gui.settings.layout.code
        if (layouts.doubleStatus === layout) {
          return toPage(VIEWS.table.custom.doubleStatus)
        }

        return toPage(VIEWS.table.queue)
      },
      showTableSettings () {
        toPage(VIEWS.table.settings)
      }
    }

    function toPage (view, params = {}) {
      store.dispatch(TIMER.lastActionTime.update)
      // https://github.com/vuejs/vue-router/issues/2881
      router.push({
        name: view.name,
        params: params
      })
        .catch((e) => {})
    }
  }
}
